/* Rorilio · PDP Paraguas : galerie, packs (une couleur par parapluie, le pack règle la quantité ; codes posés par rorilio-offers.js), barre fixe, accordéons. */
(function () {
  if (window.__pgPdp) return; window.__pgPdp = true;
  function $a(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  function addAndOpen(items, btn, onfail) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/', RO = window.RorilioOffers;
    btn.classList.add('is-busy');
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'Error'); return j; }); })
      .then(function () { return RO ? RO.reconcile(true) : null; })
      .then(function (st) { return st && !st.sections ? RO.reconcile(true) : st; }) /* passage du moteur déjà en cours, sans sections : on en relance un pour ouvrir le panier */
      .then(function (st) { btn.classList.remove('is-busy'); if (st) delete st._silent; if (!RO || !st || !st.sections || !RO.open(st)) location.href = root + 'cart'; })
      .catch(function (e) { btn.classList.remove('is-busy'); onfail(e); });
  }
  ready(function () {
    var galGo = null;
    /* Galerie */
    $a('[data-pg-gal]').forEach(function (g) {
      var sl = g.querySelector('.pg-gal__slides'), th = $a('.pg-gal__thumb', g), n = $a('.pg-gal__slide', g).length, cur = 0, tb = g.querySelector('.pg-gal__thumbs');
      function mark(i) { cur = i; th.forEach(function (t, k) { t.classList.toggle('is-on', k === i); }); var t = th[i]; if (t && tb) tb.scrollTo({ left: t.offsetLeft - tb.offsetLeft - tb.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' }); }
      function go(i) { i = (i + n) % n; var im = sl.children[i] && sl.children[i].querySelector('img'); if (im) im.loading = 'eager'; sl.scrollTo({ left: sl.clientWidth * i, behavior: 'smooth' }); mark(i); }
      galGo = go;
      th.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      $a('.pg-gal__nav', g).forEach(function (b) { b.addEventListener('click', function () { go(cur + parseInt(b.getAttribute('data-dir'), 10)); }); });
      var w; sl.addEventListener('scroll', function () { clearTimeout(w); w = setTimeout(function () { var i = Math.round(sl.scrollLeft / (sl.clientWidth || 1)); if (i !== cur) mark(i); }, 90); }, { passive: true });
    });
    /* Achat */
    $a('[data-pg-buy]').forEach(function (b) {
      var packs = $a('[data-pack]', b), sel = b.querySelector('[data-pack].is-on') || packs[0], atc = b.querySelector('[data-atc]'), err = b.querySelector('[data-err]');
      var selects = $a('[data-u]', b), sticky = document.querySelector('[data-sticky-color]'), colors = [];
      var first = selects[0] ? selects[0].value : null; for (var i = 0; i < 3; i++) colors[i] = first;
      function paintPacks() { packs.forEach(function (p) { var on = p === sel; p.classList.toggle('is-on', on); p.setAttribute('aria-checked', on ? 'true' : 'false'); }); }
      function paintColors() {
        selects.forEach(function (s) {
          s.value = colors[parseInt(s.getAttribute('data-u'), 10)];
          var o = s.options[s.selectedIndex], im = s.parentNode.querySelector('[data-u-img]');
          if (o && im) im.src = o.getAttribute('data-img');
        });
        if (sticky) sticky.value = colors[0];
      }
      function setColor(i, v, show) {
        colors[i] = v; paintColors();
        if (show && galGo) { var o = selects[i] && [].filter.call(selects[i].options, function (x) { return x.value === v; })[0]; if (o) { var p = parseInt(o.getAttribute('data-pos'), 10); if (p >= 0) galGo(p); } }
      }
      packs.forEach(function (p) {
        p.addEventListener('click', function (e) { if (e.target.closest('select')) { if (sel !== p) { sel = p; paintPacks(); } return; } sel = p; paintPacks(); });
        p.addEventListener('keydown', function (e) { if (e.target.closest('select')) return; if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); sel = p; paintPacks(); } });
      });
      selects.forEach(function (s) { s.addEventListener('change', function () { setColor(parseInt(s.getAttribute('data-u'), 10), s.value, true); }); });
      if (sticky) sticky.addEventListener('change', function () { setColor(0, sticky.value, true); });
      atc.addEventListener('click', function () {
        if (err) err.hidden = true;
        var q = parseInt(sel.getAttribute('data-qty'), 10) || 1, per = {}, order = [];
        for (var k = 0; k < q; k++) { var v = colors[k]; if (!per[v]) { per[v] = 0; order.push(v); } per[v]++; }
        addAndOpen(order.map(function (v) { return { id: Number(v), quantity: per[v] }; }), atc, function (e) { if (err) { err.textContent = e.message || 'Error'; err.hidden = false; } });
      });
      paintPacks(); paintColors();
      /* Barre fixe : après le bouton, comme la source */
      var st = document.querySelector('[data-pg-sticky]'), go = st && st.querySelector('[data-sticky-go]');
      if (st) {
        function upd() { var r = atc.getBoundingClientRect(); st.hidden = r.bottom > 0; }
        window.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
        go.addEventListener('click', function () { document.getElementById('pg-info').scrollIntoView({ behavior: 'smooth', block: 'start' }); });
      }
    });
    /* Accordéons */
    $a('[data-pg-acc]').forEach(function (list) {
      list.addEventListener('click', function (e) {
        var q = e.target.closest('[data-q]'); if (!q || !list.contains(q)) return;
        var it = q.parentElement, open = it.classList.contains('is-open');
        it.classList.toggle('is-open', !open); q.setAttribute('aria-expanded', open ? 'false' : 'true');
        var a = it.querySelector('[data-a]'); if (a) a.hidden = open;
      });
    });
  });
})();
